module.exports = __webpack_public_path__ + "img/4.ef151c93.svg";